import { z } from 'zod'
import { oc } from '@orpc/contract'
import { CONSENT_FIELD_KEYS } from './consent-sign.contract'
import { consentFieldBoxSchema, consentSignatureCellSchema } from './consent-preview.contract'

export const consentGenerate = oc
  .route({ method: 'POST', path: '/v2/consent/generate' })
  .input(
    z.object({
      // Only honored for provider-portal (Practitioner) callers, who may generate
      // consent for an arbitrary patient. Patient-portal callers are locked to
      // their own id server-side (see consent-generate.handler.ts) — any value they
      // send here is ignored, mirroring consentSign/consentGet.
      patientId: z.string(),
      organizationId: z.string(),
    }),
  )
  .output(
    z.object({
      isSigned: z.boolean(),
      // FHIR Bundle (DocumentReference + Consent) the signing UI renders.
      // Permissive schema: a precise Zod shape for a full FHIR Bundle is impractical.
      bundle: z.any().optional(),
      missingFields: z.array(z.enum(CONSENT_FIELD_KEYS)).optional(),
      fieldBoxes: z.array(consentFieldBoxSchema).optional(),
      signatureCell: consentSignatureCellSchema.optional(),
    }),
  )
